import { FileUpload } from 'primereact/fileupload'
import React, { useContext, useState } from 'react';
import './CsvUpload.css'
import { Button } from 'primereact/button';
import { IconButton } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { showToast } from '../../../ToastUtils';
import { AppContext } from '../../../../Layout/Layout';
import { Storage } from 'aws-amplify';
import TruncateText from '../../../TruncateText';

function CsvUploadButton({ t, DialogName }) {

    // Contextvariable value get from AppContext using useContext
    const { OrganizationDetails } = useContext(AppContext);

    // Files data store 
    const [SelectedFile, setSelectedFile] = useState({ DisableFile: null, EnableFile: null });
    const [uploadLoading, setuploadLoading] = useState({ DisableUpload: false, EnableUpload: false });

    // store the data to selected file state 
    const onSelect = async (event, FileType) => {
        const file = event.files[0];
        // console.log("event.name", FileType)
        if (FileType === "DisableFile") {
            setSelectedFile((prev) => ({ ...prev, DisableFile: file }));
        }
        else {
            setSelectedFile((prev) => ({ ...prev, EnableFile: file }));
        }
    };

    // clear the data from selectedfile state 
    const SelectionClear = (ClearType) => {
        if (ClearType === "DisableFile") {
            setSelectedFile((prev) => ({ ...prev, DisableFile: null }));
        } else {
            setSelectedFile((prev) => ({ ...prev, EnableFile: null }));
        }
    }

    // CSV file content change as text 
    const readFileAsText = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsText(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    // CSV file split the headers and row data 
    const parseCSV = (text) => {
        const rows = text.split('\n').filter(row => row.trim() !== '');
        const headers = rows[0].split(',');
        const data = rows.slice(1).map(row => {
            const values = row.split(',');
            return headers.reduce((obj, header, index) => {
                obj[header.trim()] = values[index] ? values[index].trim() : '';
                return obj;
            }, {});
        });

        return data;

    };

    // After confirmation Upload the csv file to S3
    const UploadToS3 = async (FileType, ConfirmFile) => {
        if (FileType === "DisableFile") {
            setuploadLoading((prev) => ({ ...prev, DisableUpload: true }));
        }
        else {
            setuploadLoading((prev) => ({ ...prev, EnableUpload: true }));
        }
        const FolderName = FileType === "DisableFile" ? "Disable" : "Enable";
        let key;
        if (DialogName === "General") {
            key = `${OrganizationDetails.tenant}/CSV_Upload/HandleProductStatus/${FolderName}/${ConfirmFile.name}`
        }
        else if (DialogName === "Customer-Specific") {
            key = `${OrganizationDetails.tenant}/CSV_Upload/RestrictCustomerSpecificProducts/${FolderName}/${ConfirmFile.name}`
        }
        try {
            // console.log("key", key)
            Storage.put(key, ConfirmFile, {
                level: 'public',
            });
            setTimeout(() => {
                showToast(t(`File uploaded successfully. You will be notified once your data are processed.`), "success", 4000);
            }, 2000);

        } catch (error) {
            console.error("Error uploading file to S3:", error);
        }
        finally {
            setTimeout(() => {
                if (FileType === "DisableFile") {
                    setuploadLoading((prev) => ({ ...prev, DisableUpload: false }));
                }
                else {
                    setuploadLoading((prev) => ({ ...prev, EnableUpload: false }));
                }
                if (FileType === "DisableFile") {
                    setSelectedFile((prev) => ({ ...prev, DisableFile: null }));
                } else {
                    setSelectedFile((prev) => ({ ...prev, EnableFile: null }));
                }
            }, 2000);

        }
    };

    //Upload process of the file 
    const handleUploadCsv = async (FileType) => {
        const ConfirmFile = FileType === "DisableFile" ? SelectedFile.DisableFile : SelectedFile.EnableFile;
        if (ConfirmFile.type === "text/csv") {
            // Checking size of the file and showing error message
            if (ConfirmFile.size > 5 * 1024 * 1024) {
                showToast(t(`File size exceeds 5 MB. Please choose a smaller file.`), "error");
                return;
            }
            else {
                try {
                    const text = await readFileAsText(ConfirmFile);
                    let csvData = parseCSV(text);
                    
                    if (DialogName === "General") {
                        csvData = csvData.filter(item => item.ProductID !== "");
                    }
                    if (csvData.length === 0) {
                        showToast(t('Uploaded file contains empty cells. Please check and try again.'), 'error', 4000);
                    }
                    else {
                        // Fields value checking empty or not 
                        const itemsWithEmptyFields = csvData.filter(item => DialogName === "Customer-Specific" ? (!item.ProductID || !item.CustomerID) : (!item.ProductID));
                        // console.log("csvData", csvData.length)
                        if (itemsWithEmptyFields.length > 0) {
                            showToast(t('Uploaded file contains empty cells. Please check and try again.'), 'error', 4000);
                        }
                        else if (csvData.length > 1000 && DialogName === "General") {
                            showToast("Only 1000 products can be enabled or disabled at a time. ", "error")
                        }
                        else {
                            UploadToS3(FileType, ConfirmFile);
                        }
                    }

                } catch (error) {
                    console.error("CSV cells checking error", error)
                }
            }

        }
        else {
            showToast(t(`Please select a CSV file.`), "error");
        }


    }


    return (
        <div className=' flex flex-column gap-4'>

            <div className='border-2 border-dashed p-1 h-7rem  border-round-lg'>

                <div className='pl-2'>
                    Disable Products {DialogName === "Customer-Specific" && "for Customers"}
                </div>

                <div className='text-center p-2 pt-3'>
                    {!SelectedFile.DisableFile ?
                        <>
                            <div className=''>
                                <FileUpload mode='basic' onSelect={(event) => onSelect(event, "DisableFile")} chooseLabel={t(`Choose File`)}
                                    chooseOptions={{ style: { width: "8rem" } }} accept=".csv" maxFileSize={500000} />
                            </div>
                            <div>
                                <span className='text-xs text-gray-500'>
                                    *{t(`Please upload a`)} <span className='font-semibold'>CSV</span> {t(`file with a maximum size limit of`)}
                                    <span className='font-semibold'> 5 MB</span>
                                </span>
                            </div>
                        </> : <>
                            <div className=''>
                                <Button onClick={() => handleUploadCsv("DisableFile")} loading={uploadLoading.DisableUpload} className='w-8rem' label='Upload' icon="pi pi-upload"></Button>
                            </div>
                            <div>
                                <span className='text-xs text-gray-500'>
                                    <TruncateText text={SelectedFile.DisableFile.name} maxLength={70} />
                                    <IconButton onClick={() => SelectionClear("DisableFile")}><CloseOutlined fontSize='small' /></IconButton>
                                </span>
                            </div>
                        </>}
                </div>


            </div>

            <div className='border-2 border-dashed p-1 h-7rem  border-round-lg'>
                <div className='pl-2'>
                    Enable Products {DialogName === "Customer-Specific" && "for Customers"}
                </div>

                <div className='text-center p-3'>
                    {!SelectedFile.EnableFile ?
                        <>
                            <div className=''>
                                <FileUpload mode='basic' onSelect={(event) => onSelect(event, "EnableFile")} chooseLabel={t(`Choose File`)}
                                    chooseOptions={{ style: { width: "8rem" } }} accept=".csv" maxFileSize={500000} />
                            </div>
                            <div>
                                <span className='text-xs text-gray-500'>
                                    *{t(`Please upload a`)} <span className='font-semibold'>CSV</span> {t(`file with a maximum size limit of`)}
                                    <span className='font-semibold'> 5 MB</span>
                                </span>
                            </div>
                        </> : <>
                            <div className=''>
                                <Button onClick={() => handleUploadCsv("EnableFile")} loading={uploadLoading.EnableUpload} className='w-8rem' label='Upload'
                                    icon="pi pi-upload"></Button>
                            </div>
                            <div>
                                <span className='text-xs text-gray-500'>
                                    <TruncateText text={SelectedFile.EnableFile.name} maxLength={70} />
                                    <IconButton onClick={() => SelectionClear("EnableFile")}><CloseOutlined fontSize='small' /></IconButton>
                                </span>
                            </div>
                        </>}
                </div>

            </div>
        </div>
    )
}

export default CsvUploadButton